import React from 'react';
import { SignIn } from '@clerk/clerk-react';

const LoginPage = () => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="bg-surface rounded-lg shadow-lg p-8 border-t-4 border-primary">
          <h2 className="text-3xl font-bold text-secondary text-center mb-6">Welcome Back</h2>
          <SignIn path="/login" routing="path" signUpUrl="/signup" />
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
